import * as yup from 'yup'

const requiredMessage = 'This field is required'

const validations = {
  questionsAndAnswers: yup
    .array()
    .min(1, 'You must have at least one question/answer')
    .of(
      yup.object().shape({
        questionText: yup.string().required(requiredMessage),
        answerText: yup.string().required(requiredMessage),
      })
    ),
  locationNames: yup
    .array()
    .min(1, 'You must select some location to post')
    .of(yup.string()),
}

export default validations
